import React from "react";

import FlagIcon from "../../images/the_arqive_flag.png";
import FlaggedIcon from "../../images/the_arqive_flag_red.png";

function Flag(props) {
  return (
    <div style={props.style}>
      <img
        style={{ width: "22px", height: "auto"}}
        onClick={() => props.flagToggle(props.pin)}
        type="submit"
        src={props.pin.userFlaggedBefore ? (props.pin.flagState ? FlaggedIcon : FlagIcon) : FlagIcon}
      />
    </div>
  );
}

export default Flag;
